import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import MetricCard from '../shared/MetricCard';
import SectionHeading from '../shared/SectionHeading';
import CardGridSkeleton from '../shared/skeletons/CardGridSkeleton';

import formatters from '../shared/formatters';

const cardGridColumns = {xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(3, minmax(0, 1fr))'};

const ExpensesCompletionSection = (props) => {
  const {
    isLoading,
    currentSnapshot,
    previousSnapshot,
  } = props;

  const expenseCards = React.useMemo(() => {
    const currentTotals = currentSnapshot?.actual?.totals || null;
    const previousTotals = previousSnapshot?.actual?.totals || null;
    const buildCard = (key, labelExpression, comparisonOptions) => ({
      key,
      label: translate(labelExpression),
      comparison: formatters.buildComparison(
          currentTotals?.[key],
          previousTotals?.[key],
          comparisonOptions,
      ),
    });

    return [
      buildCard('clientExpenses', 'metrics.ClientMetrics.ExpensesCompletion.ClientExpenses', {kind: 'currency', goodDirection: 'neutral'}),
      buildCard('caregiverExpenses', 'metrics.ClientMetrics.ExpensesCompletion.CaregiverExpenses', {kind: 'currency', goodDirection: 'neutral'}),
      buildCard('completeClientSlipCount', 'metrics.ClientMetrics.ExpensesCompletion.CompleteClientSlips', {kind: 'count', goodDirection: 'up'}),
      buildCard('incompleteClientSlipCount', 'metrics.ClientMetrics.ExpensesCompletion.IncompleteClientSlips', {kind: 'count', goodDirection: 'down'}),
      buildCard('completeCaregiverSlipCount', 'metrics.ClientMetrics.ExpensesCompletion.CompleteCaregiverSlips', {kind: 'count', goodDirection: 'up'}),
      buildCard('incompleteCaregiverSlipCount', 'metrics.ClientMetrics.ExpensesCompletion.IncompleteCaregiverSlips', {kind: 'count', goodDirection: 'down'}),
    ];
  }, [currentSnapshot, previousSnapshot]);

  return (
    <Box>
      <SectionHeading expression='metrics.ClientMetrics.ExpensesCompletion.SectionTitle' />
      <Typography
        sx={{
          fontSize: '12px',
          lineHeight: '16px',
          color: '#A8A49E',
          mt: -1.5,
          mb: 2,
        }}
      >
        <Translate expression='metrics.ClientMetrics.ExpensesCompletion.Subtitle' />
      </Typography>
      {
        isLoading &&
        <CardGridSkeleton cardCount={6} gridTemplateColumns={cardGridColumns} />
      }
      {
        !isLoading &&
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: cardGridColumns,
            gap: 1.75,
          }}
        >
          {
            expenseCards.map((card) => (
              <MetricCard
                key={card.key}
                label={card.label}
                value={card.comparison.value}
                previousValue={card.comparison.previous}
                chip={card.comparison.chip}
              />
            ))
          }
        </Box>
      }
    </Box>
  );
};

ExpensesCompletionSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  currentSnapshot: PropTypes.object,
  previousSnapshot: PropTypes.object,
};

export default React.memo(ExpensesCompletionSection);
